import React, { PropTypes } from 'react'
import isEmpty from 'lodash/isEmpty'
import isNil from 'lodash/isNil'
import moment from 'moment'

import AvailabilityDates from 'PMT/entities/menu/AvailabilityDates'
import AvailabilityDate from 'PMT/entities/menu/AvailabilityDate'

import DateUtils from 'PMT/utils/DateUtils'

import DateField from 'PMT/components/form/DateField';

export default class AvailabilityDatesForm extends React.PureComponent {

  constructor(props) {
    super(props)

    this.onDateChange('fromDate', this.fromDate)
    this.onDateChange('toDate', this.toDate)
  }

  static defaultProps = {
    availabilityDates: new AvailabilityDates(),

    readOnly: false,
  }

  static propTypes = {
    availabilityDates: PropTypes.objectOf(AvailabilityDates),

    onAvailibilityDatesChange: PropTypes.func.isRequired,

    readOnly: PropTypes.bool,
  }

  get fromDate() {
    return this.availabilityDate.fromDate || moment().startOf('day')
  }

  get toDate() {
    return this.availabilityDate.toDate || moment().endOf('day')
  }

  get availabilityDate() {
    let availabilityDate = new AvailabilityDate()

    if (!isNil(this.props.availabilityDates) && !isEmpty(this.props.availabilityDates.dates)) {
      availabilityDate = this.props.availabilityDates.dates[0]
    }

    return availabilityDate
  }

  onDateChange = (type, date) => {
    const fromDate = type === 'fromDate' ? date : this.fromDate
    const toDate = type === 'toDate' ? date : this.toDate

    const availabilityDates = new AvailabilityDates()

    availabilityDates.add(fromDate.startOf('day'), toDate.endOf('day'))

    this.props.onAvailibilityDatesChange(availabilityDates)
  }

  render() {
    return (
      <div className="col-xs-12 availability_dates_form">
        <div className="row">
          <div className="col-xs-6 col-md-3">
            <DateField
              onChange={date => this.onDateChange('fromDate', date)}
              dateFormat={DateUtils.DMY_FORMAT}
              date={this.fromDate}
            />
          </div>
          <div className="col-xs-6 col-md-3">
            <DateField
              onChange={date => this.onDateChange('toDate', date)}
              dateFormat={DateUtils.DMY_FORMAT}
              date={this.toDate}
            />
          </div>
        </div>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./scripts/pages/menu/components/availabilityDates/AvailabilityDatesForm.js